module.exports = __webpack_public_path__ + "img/ingredients-pc.86fb5588.png";